import {
	GetPublicSalaryApplicantListResponse,
	GetPublicSalaryExcelListResponse,
	GetPublicSalaryListResponse,
} from '@/services';

import { formatDate, formatNumberKR, getNoNumber } from 'utils';

export const formatPublicSalaryList = (
	input: GetPublicSalaryListResponse['list']
) => {
	return input.content.map((item, index: number) => ({
		...item,
		no: getNoNumber(input, index),
	}));
};

export const formatPublicSalaryListDetail = (
	input: any,
	formatExcel: boolean = false
) => {
	return {
		...input,
		id: input.franchisePublicId,
		franchisePublicName: input.franchisePublicName || '-',
		applicantCnt: `${formatNumberKR(input.applicantCnt)}명`,
		dayWorkAvg: `${formatNumberKR(input.dayWorkAvg)}일`,
		monthWorkAvg: `${formatNumberKR(input.monthWorkAvg)}개월`,
		salary: `${formatNumberKR(input.salary)}원`,
		lodgingCost: `${formatNumberKR(input.lodgingCost)}원`,
		totalCost: `${formatNumberKR(input.totalCost)}원`,
	};
};

export const formatPublicSalaryDetail = (input: any) => {
	const newInput = input?.list?.content?.[0] || {};
	return {
		...formatPublicSalaryListDetail(newInput),
		franchisePublicEmployerPhone: newInput.franchisePublicEmployerPhone || '-',
		franchisePublicAddress: newInput.franchisePublicAddress,
	};
};

export const formatPublicSalaryExcelList = (
	input: GetPublicSalaryExcelListResponse['list']
) => {
	return input.content.map((item: any, index: number) => ({
		...formatPublicSalaryListDetail(item, true),
		no: getNoNumber(input, index),
	}));
};

export const formatPublicSalaryApplicantListDetail = (
	input: GetPublicSalaryApplicantListResponse['content'][number]
) => {
	return {
		...input,
		id: input.applicantId,
		applicantName: input.applicantName || '',
		applicantBirthDate: formatDate(input?.applicantBirthDate),
		applicantEntryDate: formatDate(input?.applicantEntryDate),
		applicantDepartureDate: formatDate(input?.applicantDepartureDate),
		workStartDate: formatDate(input?.workStartDate),
		workEndDate: formatDate(input?.workEndDate),
		dayWorkCnt: `${formatNumberKR(input?.dayWorkCnt || 0)}일`,
		monthWorkCnt: `${formatNumberKR(input?.monthWorkCnt || 0)}개월`,
		grade: input?.grade
			? input?.grade === 'BASIC_GRADE'
				? '기본 등급'
				: `${input?.grade?.replace('GRADE_', '')}`
			: '',
		salaryDay: `${formatNumberKR(input?.salaryDay || 0)}원`,
		totalSalary: `${formatNumberKR(input?.totalSalary || 0)}원`,
		lodgingCost: `${formatNumberKR(input?.lodgingCost || 0)}원`,
		totalLodgingCost: `${formatNumberKR(input?.totalLodgingCost || 0)}원`,
		mealCost: `${formatNumberKR(input?.mealCost || 0)}원`,
		totalMealCost: `${formatNumberKR(input?.totalMealCost || 0)}원`,
		totalLodgingMealCost: `${formatNumberKR(input?.totalLodgingMealCost || 0)}원`,
		totalCost: `${formatNumberKR(input?.totalCost || 0)}원`,
	};
};

export const formatPublicSalaryApplicantList = (
	input: GetPublicSalaryApplicantListResponse['content']
) => {
	return input.map((item: any) => ({
		...formatPublicSalaryApplicantListDetail(item),
	}));
};
